import { ControleManquementEdition } from './controle-manquement-edition.model';
import { ControleEchantillonEdition } from './controle-echantillon-edition.model';
import { ControleOperateurEdition } from './controle-operateur-edition.model';
import { ControleSiteEdition } from './controle-site-edition.model';
import { OrganismeEdition } from './organisme-edition.model';
import { ArrayClassConverterFactory, ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class ControleEdition {
    static jsonMap = {
        id: { key: 'id', optional: true },
        typeControle: { key: 'typeControle', optional: true, default: '' },
        dateNotification: { key: 'dateNotification', optional: true, default: '' },
        dateControle: { key: 'dateControle', optional: true, default: '' },
        actionCorrectiveProposee: { key: 'actionCorrectiveProposee', optional: true, default: '' },
        estConforme: { key: 'estConforme', optional: true, default: '' },
        manquements: { key: 'manquements', converter: new (ArrayClassConverterFactory.build(ControleManquementEdition))(), optional: true, default: () => [] },
        echantillon: { key: 'echantillon', converter: new (ClassConverterFactory.build(ControleEchantillonEdition))(), optional: true },
        operateur: { key: 'operateur', converter: new (ClassConverterFactory.build(ControleOperateurEdition))(), optional: true },
        site: { key: 'site', converter: new (ClassConverterFactory.build(ControleSiteEdition))(), optional: true },
        organisme: { key: 'organisme', converter: new (ClassConverterFactory.build(OrganismeEdition))(), optional: true }
    };

    id: number;
    typeControle: string;
    dateNotification: string;
    dateControle: string;
    actionCorrectiveProposee: string;
    estConforme: string;
    manquements: ControleManquementEdition[];
    echantillon: ControleEchantillonEdition;
    operateur: ControleOperateurEdition;
    site: ControleSiteEdition;
    organisme: OrganismeEdition;
}
